import axios from "axios";
import { API_ENDPOINT } from "../../../configurations/global.config";
import { PaymentTaskState } from "../../../enums/tasks";
import { timestampedMessage } from "../../common/multi-package-scanner/multi-package-scanner";

export const collectInvoice = async (payment_task_id: string, request_config: any, onSuccess: () => void, setSnackBarResult: (t?: timestampedMessage) => void) => {
    try {
        const url = `${API_ENDPOINT}/api/v1/payment-task/${payment_task_id}/`;
        const requestData = {
            status: PaymentTaskState.OUT_FOR_PAYMENT,
        };
        const response = await axios.patch(url, requestData, request_config);
        setSnackBarResult({
            timestamp: Date.now(),
            content: "Invoice updated",
            level: 'success',
        })
        onSuccess();
        return;
    } catch (e) {
        setSnackBarResult({
            timestamp: Date.now(),
            content: "An Error Occured",
            level: 'error',
        })
    }
}